import { render, staticRenderFns } from "./CoursesBeam.vue?vue&type=template&id=a5d812f6&"
import script from "./CoursesBeam.vue?vue&type=script&lang=js&"
export * from "./CoursesBeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports